export interface Article {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  imageUrl: string;
  imageUrlThumb: string;
  imageUrlFeature: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    id: 1,
    slug: 'baijie-first-encounter',
    title: '少妇白洁初遇篇：一场意外的邂逅改变了她的命运',
    excerpt: '在那个平凡的午后，白洁遇见了改变她一生的那个人。她的故事从这里开始，一段关于情感、欲望与自我觉醒的旅程徐徐展开。',
    content: `<p>那是一个再普通不过的午后，阳光透过窗帘的缝隙洒在客厅的地板上，形成一道道光影交错的纹路。白洁坐在沙发上，手里捧着一本书，却怎么也看不进去。</p>
<p>她的生活就像一杯温吞的白开水——不冷不热，毫无波澜。丈夫工作忙碌，常年出差，两人之间的交流越来越少。她有时候会想，这真的是她想要的生活吗？</p>
<p>就在那天下午，她接到了一个意外的电话。电话那头的声音温和而富有磁性，像是冬日里的一杯热茶，让人不由自主地想要靠近。</p>
<p>「您好，请问是白洁女士吗？」</p>
<p>「我是。」她的声音有些迟疑。</p>
<p>「我是陈默，您先生的同事。他让我帮忙送一份文件过来，不知道您现在方便吗？」</p>
<p>白洁犹豫了一下，但还是答应了。她起身整理了一下头发，换上了一条素雅的连衣裙。镜子里的自己看起来依然年轻，只是眼神里少了些光彩。</p>
<p>半小时后，门铃响了。她打开门，看到了站在门外的陈默。他比她想象中要年轻，眉宇间带着一种儒雅的气质，眼神温和而深邃。</p>
<p>「请进。」她侧身让开。</p>
<p>陈默走进客厅，将文件放在茶几上。他环顾了一下四周，目光落在墙上的那幅画上。</p>
<p>「这幅画很美。」他说。</p>
<p>「是我画的。」白洁的声音里带着一丝不易察觉的自豪。</p>
<p>陈默转过头看着她，眼神中闪过一丝惊讶：「真的？很有灵气。」</p>
<p>就是这一句话，让白洁的心里泛起了一丝涟漪。已经很久没有人这样认真地看过她了，更没有人这样真诚地赞美过她。</p>
<p>那天下午，他们聊了很久。关于画，关于生活，关于那些被日常琐碎淹没了的梦想。当陈默离开的时候，夕阳已经染红了半边天空。</p>
<p>白洁站在门口，看着他的背影消失在电梯里。她忽然意识到，自己的生活也许可以从今天开始变得不一样。</p>`,
    category: 'story-appreciation',
    author: '文学编辑组',
    date: '2025-12-15',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20woman%20standing%20by%20a%20window%20in%20a%20sunlit%20apartment%2C%20gentle%20afternoon%20sunlight%20creating%20warm%20shadows%2C%20feminine%20elegant%20interior%20with%20books%20and%20art%2C%20contemplative%20mood%2C%20soft%20cream%20and%20warm%20gold%20tones%2C%20cinematic%20composition%2C%20shallow%20depth%20of%20field&width=600&height=400&seq=article-card-1&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=A%20woman%20standing%20by%20a%20window%20in%20a%20sunlit%20apartment%2C%20gentle%20afternoon%20sunlight%2C%20warm%20cream%20and%20gold%20tones&width=160&height=160&seq=article-thumb-1&orientation=squarish',
    imageUrlFeature: 'https://readdy.ai/api/search-image?query=A%20woman%20standing%20by%20a%20window%20in%20a%20sunlit%20apartment%2C%20gentle%20afternoon%20sunlight%20creating%20warm%20shadows%2C%20feminine%20elegant%20interior%2C%20cinematic%20composition&width=800&height=450&seq=article-featured-1&orientation=landscape',
    tags: ['白洁初遇', '都市情感', '女性觉醒'],
    featured: true,
  },
  {
    id: 2,
    slug: 'baijie-marriage-dilemma',
    title: '白洁的婚姻困境：在责任与自我之间的艰难抉择',
    excerpt: '面对冷漠的婚姻和内心的渴望，白洁陷入了前所未有的挣扎。这是每一个都市女性都可能面临的灵魂拷问。',
    content: `<p>婚后的第七年，白洁终于开始认真思考一个问题：婚姻的意义到底是什么？</p>
<p>她和丈夫张明的婚姻，从一开始的甜蜜逐渐变成了如今相敬如宾的日常。没有争吵，没有背叛，却也没有了温度。两个人像两条平行线，生活在同一个屋檐下，却很少真正交汇。</p>
<p>「你今天几点回来？」白洁在电话里问。</p>
<p>「不确定，有个会要开，可能很晚。你不用等我吃饭。」张明的声音匆忙而疏离。</p>
<p>这样的对话，几乎每天都在重复。白洁已经习惯了独自吃饭，习惯了在空荡荡的客厅里度过一个又一个夜晚。</p>
<p>她曾经试图改变。她学着做新菜，计划旅行，甚至尝试和他交流自己内心的感受。但每次话到嘴边，看到张明疲惫的神情，她又把话咽了回去。</p>
<p>「你是不是觉得我们的婚姻出了问题？」有一天晚上，白洁终于问出了口。</p>
<p>张明愣了一下，然后笑了笑：「你想多了吧？我们都挺好的啊。」</p>
<p>挺好的。这就是他的答案。白洁忽然感到一阵深深的孤独——比一个人独处时更深的孤独。因为在这个应该最亲密的婚姻关系里，她连表达真实感受的勇气都在一点点消磨殆尽。</p>
<p>她开始重新审视自己的人生。一个女人的价值，难道就只在于成为一个好妻子吗？她的梦想、她的渴望、她作为一个独立个体的存在，是否还有意义？</p>`,
    category: 'story-appreciation',
    author: '文学编辑组',
    date: '2025-11-28',
    readTime: '10分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20woman%20sitting%20alone%20at%20a%20dining%20table%20with%20a%20single%20candle%20lit%2C%20evening%20light%20through%20window%2C%20melancholic%20yet%20beautiful%20atmosphere%2C%20warm%20amber%20lighting%2C%20soft%20shadows&width=600&height=400&seq=article-card-2&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=A%20woman%20sitting%20alone%20at%20a%20dining%20table%20candle%20lit%2C%20evening%20light%2C%20melancholic%20atmosphere&width=160&height=160&seq=article-thumb-2&orientation=squarish',
    imageUrlFeature: 'https://readdy.ai/api/search-image?query=A%20woman%20sitting%20alone%20at%20a%20dining%20table%20with%20a%20single%20candle%20lit%2C%20evening%20light%20through%20window%2C%20warm%20amber%20lighting&width=800&height=450&seq=article-featured-2&orientation=landscape',
    tags: ['婚姻困惑', '女性成长', '情感抉择'],
    featured: true,
  },
  {
    id: 3,
    slug: 'baijie-self-discovery',
    title: '白洁的自我觉醒之路：从迷失到找回自己的旅程',
    excerpt: '在经历了情感的起伏之后，白洁终于开始学会爱自己。她的成长故事，激励着无数在婚姻中迷失自我的女性。',
    content: `<p>白洁开始每天早晨在日记本上写下三个字：「我是谁？」</p>
<p>这个简单的问题，她却花费了很长时间来回答。因为在过去的七年里，她一直是「张明的妻子」、「孩子的母亲」、「别人眼中的好女人」。但这些身份之下，真正的白洁在哪里？</p>
<p>她重新拿起了画笔。久违的色彩在画布上流淌，那些被压抑太久的情感终于找到了表达的出口。她报名参加了画室的课程，在那里，没有人知道她是谁的妻子，她只是一个热爱绘画的女性。</p>
<p>「你的画里有故事。」画室的老师说。</p>
<p>白洁笑了，那是很久以来她第一次发自内心的笑。</p>
<p>她开始读书，读那些以前没有时间读的书。她开始运动，感受身体的力量和活力。她开始和朋友们聚会，分享彼此的生活和感悟。慢慢地，那个鲜活的白洁，正在一点点回来。</p>`,
    category: 'character-analysis',
    author: '文学编辑组',
    date: '2025-11-10',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20woman%20painting%20at%20an%20easel%20in%20a%20bright%20art%20studio%2C%20sunlight%20streaming%20through%20large%20windows%2C%20colorful%20paint%20palette%2C%20expression%20of%20concentration%20and%20peace&width=600&height=400&seq=article-card-3&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=A%20woman%20painting%20at%20an%20easel%20in%20a%20bright%20art%20studio%2C%20sunlight%20large%20windows&width=160&height=160&seq=article-thumb-3&orientation=squarish',
    imageUrlFeature: 'https://readdy.ai/api/search-image?query=A%20woman%20painting%20at%20an%20easel%20in%20a%20bright%20art%20studio%2C%20sunlight%20streaming%20through%20large%20windows%2C%20colorful%20palette&width=800&height=450&seq=article-featured-3&orientation=landscape',
    tags: ['自我觉醒', '女性力量', '成长蜕变'],
    featured: true,
  },
  {
    id: 4,
    slug: 'baijie-friendship-power',
    title: '白洁与闺蜜：女性友谊在情感困境中的治愈力量',
    excerpt: '在白洁最迷茫的时候，是她的闺蜜们给予了她最温暖的支持。这段关于女性友谊的故事，让人感动落泪。',
    content: `<p>那天晚上，白洁接到了闺蜜小雅的电话。</p>
<p>「出来坐坐吧，我知道你最近不太好。」小雅的声音温柔而坚定。</p>
<p>她们在一家安静的茶馆见了面。昏黄的灯光下，白洁第一次毫无保留地倾诉了自己内心的挣扎。她说了很多，眼泪也不争气地流了下来。</p>
<p>小雅静静地听着，没有打断，没有评判。等白洁说完，她才轻轻握住她的手：「你知道吗？你已经很勇敢了。」</p>
<p>「勇敢？」白洁苦笑，「我觉得自己很懦弱。」</p>
<p>「敢于面对自己的内心，敢于承认不快乐，这本身就是一种勇气。」小雅说，「大多数人都选择麻木地过日子，你却在寻找答案。这难道不勇敢吗？」</p>
<p>那天晚上，她们聊到茶馆打烊。白洁走出茶馆的时候，发现自己的脚步轻盈了许多。</p>`,
    category: 'emotional-topics',
    author: '文学编辑组',
    date: '2025-10-22',
    readTime: '6分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20women%20sharing%20tea%20in%20a%20cozy%20traditional%20Chinese%20tea%20house%2C%20warm%20ambient%20lighting%2C%20intimate%20atmosphere%2C%20soft%20focus%2C%20elegant%20interior&width=600&height=400&seq=article-card-4&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Two%20women%20sharing%20tea%20in%20a%20cozy%20traditional%20Chinese%20tea%20house%2C%20warm%20ambient%20lighting&width=160&height=160&seq=article-thumb-4&orientation=squarish',
    imageUrlFeature: 'https://readdy.ai/api/search-image?query=Two%20women%20sharing%20tea%20in%20a%20cozy%20traditional%20Chinese%20tea%20house%2C%20warm%20ambient%20lighting%2C%20intimate%20atmosphere&width=800&height=450&seq=article-featured-4&orientation=landscape',
    tags: ['女性友谊', '情感支持', '心灵治愈'],
    featured: false,
  },
  {
    id: 5,
    slug: 'baijie-character-depth',
    title: '解读白洁：一个都市女性的复杂灵魂与人性光辉',
    excerpt: '白洁不是一个完美的女性形象，但正因如此，她才如此真实。本文深入剖析白洁性格中的矛盾与魅力。',
    content: `<p>在都市情感文学的谱系中，白洁是一个极为特别的存在。她既不是传统意义上的「贤妻良母」，也不是现代都市剧中标签化的「独立女性」。她处在一个灰色地带——既有传统价值观的烙印，又渴望突破束缚，追寻真实的自我。</p>
<p>这种矛盾性恰恰是白洁这个角色最吸引人的地方。她不是一个符号，而是一个有血有肉的人。她会犹豫，会犯错，会在道德与欲望之间挣扎。这些挣扎让读者在她身上看到了自己的影子。</p>
<p>白洁的内心世界丰富而细腻。她对美的感知，对情感的敏锐，对生活的热爱，都构成了她独特的魅力。即使在最困顿的时刻，她也从未完全失去对美好事物的向往。这种在困境中依然保持的精神追求，让她的形象充满了人性的光辉。</p>`,
    category: 'character-analysis',
    author: '文学编辑组',
    date: '2025-10-08',
    readTime: '9分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Artistic%20portrait%20of%20a%20woman%20with%20complex%20expression%2C%20half%20in%20shadow%20half%20in%20light%2C%20symbolizing%20inner%20struggle%2C%20warm%20and%20cool%20tones%20blending&width=600&height=400&seq=article-card-5&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Artistic%20portrait%20of%20a%20woman%20with%20complex%20expression%2C%20half%20shadow%20half%20light&width=160&height=160&seq=article-thumb-5&orientation=squarish',
    imageUrlFeature: 'https://readdy.ai/api/search-image?query=Artistic%20portrait%20of%20a%20woman%20with%20complex%20expression%2C%20half%20in%20shadow%20half%20in%20light%2C%20inner%20struggle&width=800&height=450&seq=article-featured-5&orientation=landscape',
    tags: ['人物剖析', '性格分析', '人性探索'],
    featured: false,
  },
  {
    id: 6,
    slug: 'love-marriage-modern-women',
    title: '当代女性的爱与婚姻：白洁故事引发的社会思考',
    excerpt: '白洁的故事不仅仅是一个女人的故事，它折射出当代社会中无数女性面临的共同困境与选择。',
    content: `<p>「白洁」之所以能够引发如此广泛的共鸣，根本原因在于她的故事触及了一个普遍性的社会议题——当代女性在婚姻中如何自处。</p>
<p>在传统观念中，女性被期待成为家庭的守护者，用温柔和包容维系婚姻。然而，随着女性意识的觉醒和经济地位的提升，越来越多的女性开始质疑这种角色定位：为什么维系婚姻的责任总是落在女性身上？为什么女性的自我实现总要以牺牲婚姻为代价？</p>
<p>白洁的故事之所以动人，正在于她没有简单地在「离开」和「忍受」之间二选一。她在寻找第三条路——在不完全放弃现有生活的基础上，找回那个被遗忘的自我。这种探索本身，就是对传统二元对立的超越。</p>`,
    category: 'emotional-topics',
    author: '文学编辑组',
    date: '2025-09-20',
    readTime: '11分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20woman%20looking%20at%20cityscape%20through%20floor%20to%20ceiling%20windows%2C%20reflective%20mood%2C%20warm%20sunset%20light%2C%20contemporary%20interior&width=600&height=400&seq=article-card-6&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20woman%20looking%20at%20cityscape%20through%20windows%2C%20warm%20sunset%20light&width=160&height=160&seq=article-thumb-6&orientation=squarish',
    imageUrlFeature: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20woman%20looking%20at%20cityscape%20through%20floor%20to%20ceiling%20windows%2C%20reflective%20mood%2C%20warm%20sunset&width=800&height=450&seq=article-featured-6&orientation=landscape',
    tags: ['社会思考', '女性议题', '婚姻观念'],
    featured: false,
  },
  {
    id: 7,
    slug: 'baijie-narrative-art',
    title: '白洁系列的叙事艺术：细腻笔触下的情感张力与文学价值',
    excerpt: '从文学创作的角度来看，白洁系列之所以具有强烈的感染力，与其精湛的叙事技巧密不可分。',
    content: `<p>白洁系列在叙事手法上展现了相当高的技艺。作者善用细节描写来构建情感氛围——一个回眸、一杯凉掉的茶、窗台上的一抹斜阳，这些看似平淡的细节在铺陈中发酵，最终汇聚成汹涌的情感洪流。</p>
<p>在叙事视角的选择上，作品采用了贴近主人公内心的内聚焦视角，让读者能够直接感受到白洁的情绪波动和内心独白。这种写法拉近了读者与人物的距离，使读者能够与白洁产生深度的情感共振。</p>
<p>语言风格上，作品融合了传统文学的诗意与当代口语的鲜活，既不失文学品格，又具有极强的可读性。这种雅俗共赏的写作风格，是白洁系列能够获得广泛读者群的重要原因。</p>`,
    category: 'literary-review',
    author: '文学编辑组',
    date: '2025-09-05',
    readTime: '12分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20writing%20desk%20with%20manuscript%20pages%20scattered%2C%20fountain%20pen%2C%20warm%20lamp%20light%2C%20vintage%20aesthetic%2C%20literary%20atmosphere%2C%20soft%20sepia%20tones&width=600&height=400&seq=article-card-7&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Elegant%20writing%20desk%20with%20manuscript%20pages%2C%20fountain%20pen%2C%20warm%20lamp%20light&width=160&height=160&seq=article-thumb-7&orientation=squarish',
    imageUrlFeature: 'https://readdy.ai/api/search-image?query=Elegant%20writing%20desk%20with%20manuscript%20pages%20scattered%2C%20fountain%20pen%2C%20warm%20lamp%20light%2C%20vintage%20literary&width=800&height=450&seq=article-featured-7&orientation=landscape',
    tags: ['叙事分析', '文学评论', '写作艺术'],
    featured: false,
  },
  {
    id: 8,
    slug: 'baijie-emotional-growth',
    title: '从依赖到独立：白洁情感成长轨迹的心理学解读',
    excerpt: '借助心理学视角，我们可以更深入地理解白洁在情感世界中的成长和蜕变过程。',
    content: `<p>从心理学的角度审视白洁的成长轨迹，我们可以看到一条清晰的心理发展路径：从情感依赖到自我觉醒，再到最终的独立和整合。</p>
<p>在故事的早期，白洁呈现出典型的情感依赖特征。她将自我价值很大程度上寄托在婚姻关系上，渴望通过他人的认可来确认自己的存在意义。这种心理状态在当代女性中并不少见，尤其是在那些接受了传统性别角色教育的女性中。</p>
<p>随着故事的发展，白洁经历了一系列心理上的震荡和突破。她开始质疑既有的生活模式，尝试表达长期被压抑的个人需求。这个过程虽然伴随着痛苦和不安，但却是心理成长的重要阶段。</p>`,
    category: 'character-analysis',
    author: '文学编辑组',
    date: '2025-08-18',
    readTime: '10分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Abstract%20art%20depicting%20personal%20growth%20and%20transformation%2C%20warm%20rising%20gradient%20colors%2C%20butterfly%20metaphor%2C%20soft%20textures%2C%20feminine%20energy&width=600&height=400&seq=article-card-8&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Abstract%20art%20depicting%20personal%20growth%20transformation%2C%20warm%20gradient%20colors%2C%20feminine%20energy&width=160&height=160&seq=article-thumb-8&orientation=squarish',
    imageUrlFeature: 'https://readdy.ai/api/search-image?query=Abstract%20art%20depicting%20personal%20growth%20and%20transformation%2C%20warm%20rising%20gradient%20colors%2C%20soft%20textures&width=800&height=450&seq=article-featured-8&orientation=landscape',
    tags: ['心理分析', '情感成长', '自我认知'],
    featured: false,
  },
  {
    id: 9,
    slug: 'modern-marriage-literature',
    title: '都市婚恋文学的创作趋势：白洁现象背后的文化密码',
    excerpt: '白洁系列的走红并非偶然，它反映了当下社会对婚恋叙事的深层需求和文化心理变迁。',
    content: `<p>近年来，都市婚恋题材文学持续走热，白洁系列的广泛传播便是这一文化现象的典型代表。探究其背后的社会文化动因，我们可以发现几个关键因素。</p>
<p>首先是社会转型期的情感焦虑。在快速城市化的进程中，传统的婚恋观念与现代个体意识之间产生了激烈的碰撞。人们既渴望稳定的情感关系，又不愿完全牺牲个人自由和发展空间。白洁的故事恰恰切中了这种普遍的矛盾心理。</p>
<p>其次是女性读者群体的崛起。随着女性受教育程度和经济地位的提升，她们对文学作品中女性形象有了更高的期待。白洁这个角色的复杂性和真实性，满足了现代女性读者对深度情感叙事的渴求。</p>`,
    category: 'literary-review',
    author: '文学编辑组',
    date: '2025-08-02',
    readTime: '13分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20cityscape%20at%20twilight%20with%20warm%20glowing%20windows%2C%20urban%20romance%20atmosphere%2C%20soft%20bokeh%20lights%2C%20warm%20amber%20tones&width=600&height=400&seq=article-card-9&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Modern%20cityscape%20at%20twilight%20with%20warm%20glowing%20windows%2C%20urban%20romance%20atmosphere&width=160&height=160&seq=article-thumb-9&orientation=squarish',
    imageUrlFeature: 'https://readdy.ai/api/search-image?query=Modern%20cityscape%20at%20twilight%20with%20warm%20glowing%20windows%2C%20urban%20romance%20atmosphere%2C%20soft%20bokeh&width=800&height=450&seq=article-featured-9&orientation=landscape',
    tags: ['文学趋势', '文化分析', '婚恋叙事'],
    featured: false,
  },
  {
    id: 10,
    slug: 'baijie-reader-letters',
    title: '读者来信精选：白洁故事如何在千万女性心中激起共鸣',
    excerpt: '我们收到了来自全国各地读者的来信，她们分享了自己与白洁故事的情感连接。这些真挚的文字令人动容。',
    content: `<p>自白洁系列故事发布以来，我们的编辑部收到了成百上千封读者来信。这些来信来自不同年龄、不同背景的女性，但她们的字里行间都流露出一种共同的情感——被理解、被看见的感觉。</p>
<p>一位来自广州的读者写道：「读白洁的故事，就像在看自己的日记。她的每一个犹豫、每一次挣扎，我都经历过。谢谢你让我知道，我不是一个人。」</p>
<p>另一位来自成都的读者分享道：「我今年45岁，孩子上大学后突然发现自己的生活空了。白洁的故事让我重新思考自己的人生，我开始学跳舞了。」</p>
<p>这些来信中最令人动容的，是那些坦诚分享自己婚姻困境的女性。她们中有人选择了改变，有人选择了离开，也有人选择了接受。但无论选择如何，白洁的故事都给了她们一份珍贵的礼物——被理解的温暖。</p>`,
    category: 'emotional-topics',
    author: '文学编辑组',
    date: '2025-07-15',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stack%20of%20handwritten%20letters%20with%20warm%20lighting%2C%20elegant%20stationery%2C%20dried%20flowers%20beside%20letters%2C%20nostalgic%20atmosphere%2C%20soft%20cream%20sepia&width=600&height=400&seq=article-card-10&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Stack%20of%20handwritten%20letters%20with%20warm%20lighting%2C%20dried%20flowers%2C%20nostalgic%20atmosphere&width=160&height=160&seq=article-thumb-10&orientation=squarish',
    imageUrlFeature: 'https://readdy.ai/api/search-image?query=Stack%20of%20handwritten%20letters%20with%20warm%20lighting%2C%20elegant%20stationery%2C%20dried%20flowers%2C%20nostalgic&width=800&height=450&seq=article-featured-10&orientation=landscape',
    tags: ['读者来信', '情感共鸣', '真实故事'],
    featured: false,
  },
  {
    id: 11,
    slug: 'baijie-inner-world',
    title: '走进白洁的内心世界：那些未曾说出口的独白与渴望',
    excerpt: '在白洁平静的外表之下，隐藏着一个丰富而复杂的精神世界。让我们透过文字的表层，聆听她内心深处的真实声音。',
    content: `<p>表面上，白洁是一个安静、温柔的女性。她说话轻声细语，待人接物得体周到，在任何社交场合都不会引起特别的注意。但在这层平静的外壳之下，藏着一个风暴般的内心世界。</p>
<p>她渴望被真正地看见——不是作为某个男人的妻子，不是作为某个社会角色的扮演者，而是作为她自己，一个有着独立思想和丰富情感的人。</p>
<p>她渴望被理解——不是被评判，不是被指导，而是被一个能够聆听她所有困惑和挣扎的人理解。这种渴望如此强烈，以至于她会对着空房间自言自语，会在日记里写下大段大段的心事。</p>
<p>她也渴望爱——一种真正平等的、能够滋养彼此灵魂的爱。不是责任的捆绑，不是习惯的延续，而是一种能让两个独立的灵魂相互照耀的光芒。</p>`,
    category: 'character-analysis',
    author: '文学编辑组',
    date: '2025-06-28',
    readTime: '9分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Woman%20writing%20in%20a%20journal%20by%20candlelight%2C%20intimate%20and%20private%20moment%2C%20soft%20warm%20glow%2C%20feminine%20aesthetic%2C%20contemplative%20mood&width=600&height=400&seq=article-card-11&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Woman%20writing%20in%20a%20journal%20by%20candlelight%2C%20intimate%20private%20moment%2C%20soft%20warm%20glow&width=160&height=160&seq=article-thumb-11&orientation=squarish',
    imageUrlFeature: 'https://readdy.ai/api/search-image?query=Woman%20writing%20in%20a%20journal%20by%20candlelight%2C%20intimate%20and%20private%20moment%2C%20soft%20warm%20glow&width=800&height=450&seq=article-featured-11&orientation=landscape',
    tags: ['内心独白', '情感表达', '自我探索'],
    featured: false,
  },
  {
    id: 12,
    slug: 'literature-and-life',
    title: '文学与生活的距离：白洁教会我们的那些事',
    excerpt: '文学从来不是生活的简单复制，但好的文学作品总能让读者在虚构中找到生活的真相。',
    content: `<p>有人问：白洁的故事是真实的吗？从情节上来说，它是一部虚构作品。但从情感的真实性上来说，它比许多所谓的「纪实」更加贴近生活的本质。</p>
<p>白洁教会我们的第一件事是：真实的感情从来不是非黑即白的。生活中的选择很少有绝对的对错，更多的是在各种不完美的选项之间寻找最适合自己的那一个。</p>
<p>她教会我们的第二件事是：成长从来不是一蹴而就的。白洁的蜕变经历了漫长的过程，有过反复，有过退却，有过自我怀疑。但这恰恰是真实成长的样子——它不是一条直线，而是一条蜿蜒曲折的上坡路。</p>
<p>最重要的一点是，白洁告诉我们：无论如何，都不要放弃寻找自己的勇气。一个人的一生中，最重要的关系不是与任何他人的关系，而是与自己的关系。</p>`,
    category: 'literary-review',
    author: '文学编辑组',
    date: '2025-06-10',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Open%20book%20on%20a%20windowsill%20with%20sunlight%20streaming%20through%2C%20view%20of%20garden%20outside%2C%20peaceful%20reading%20atmosphere%2C%20warm%20natural%20light&width=600&height=400&seq=article-card-12&orientation=landscape',
    imageUrlThumb: 'https://readdy.ai/api/search-image?query=Open%20book%20on%20a%20windowsill%20with%20sunlight%2C%20garden%20view%2C%20peaceful%20reading%20atmosphere&width=160&height=160&seq=article-thumb-12&orientation=squarish',
    imageUrlFeature: 'https://readdy.ai/api/search-image?query=Open%20book%20on%20a%20windowsill%20with%20sunlight%20streaming%20through%2C%20view%20of%20garden%2C%20peaceful%20reading&width=800&height=450&seq=article-featured-12&orientation=landscape',
    tags: ['人生感悟', '文学哲思', '生活智慧'],
    featured: false,
  },
];